import { render, staticRenderFns } from "./SegmentedControl.vue?vue&type=template&id=34ce457c&scoped=true&"
import script from "./SegmentedControl.vue?vue&type=script&lang=js&"
export * from "./SegmentedControl.vue?vue&type=script&lang=js&"
import style0 from "./SegmentedControl.vue?vue&type=style&index=0&id=34ce457c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ce457c",
  null
  
)

export default component.exports